import { UppKonvaShape } from '../upp-konva-shape';
import type { UppKonvaSofaShapeOptions } from '../upp-konva-options';

/** Sofa shape. */
export class UppKonvaSofaShape extends UppKonvaShape {
    // 1. Type contract
    readonly kind = 'SOFA' as const;

    // 2. Lifecycle
    constructor(opts: UppKonvaSofaShapeOptions) {
        const { shape, ...rest } = opts;
        super({ ...rest, data: { shape } });
    }
}
